module.exports = __webpack_public_path__ + "img/stomach.75e94017.png";